export const emailOpenApiDescription = {
	description: 'Email address of the user',
	example: 'email@example.com',
};

export const passwordOpenApiDescription = {
	description: 'User’s plain text password',
	example: 'P@ssw0rd!',
};

export const nameOpenApiDescription = {
	description: 'Full name of the user',
	example: 'John Doe',
};

export const successOpenApiDescription = {
	description: 'Indicates whether the api call was successful',
	example: true,
};
